/* global jQuery */
import "../sass/main.scss";
import 'lazysizes';
import jQuery from "jquery";
import imagesLoaded from "imagesloaded";
import Barba from "barba.js";
import Flickity from "flickity";
import jQueryBridget from "jquery-bridget";
import Packery from "packery";
import initStickySidebar from "./sticky-sidebar";
import initStars from "./stars.js";
import initHeroControls from "./hero-controls.js";
import { debounce, throttle, prefersReducedMotion } from "./util.js";
import Typewriter from 'typewriter-effect/dist/core';
import {TimelineLite, TweenLite, TweenMax, Power1, Power4, Expo, gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
window.$ = window.jQuery = jQuery;

jQueryBridget( 'flickity', Flickity, $ );

gsap.registerPlugin(ScrollToPlugin)


var CA = CA || {},
    _hsq = (window._hsq = window._hsq || []);

CA.mq = {
    sm: "(min-width: 576px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 1024px)",
};

CA.body_class = "";
CA.initial_load = true;
CA.to_animate = [];

CA.ajax_transition_active = false;

// Reduced motion keeps the page transitions — everything still cross-fades —
// but strips the travel out of them. Wrap a tween's vars in CA.still() and the
// translate/scale/rotate values drop out when the visitor has asked for less
// motion, leaving the opacity work untouched.
var TRAVEL_PROPS = ["x", "y", "z", "scale", "scaleX", "scaleY", "rotation", "rotationX", "rotationY"];

CA.still = function (vars) {
    if (!prefersReducedMotion()) {
        return vars;
    }

    var out = {};

    Object.keys(vars).forEach(function (key) {
        if (TRAVEL_PROPS.indexOf(key) === -1) {
            out[key] = vars[key];
        }
    });

    return out;
};

CA.scroll_to_top = function () {
    if (window.scrollTo) {
        window.scrollTo(0, 0);
    }
    if (document.documentElement) {
        document.documentElement.scrollTop = 0;
    }
    if (document.body) {
        document.body.scrollTop = 0;
    }
};

CA.init_ajax = function () {
    var linkClicked = true;

    // Prevent the browser from restoring the previous scroll position on
    // pushState navigations — it races with our scrollTop(0) and was the
    // cause of intermittent scroll-to-top failures between transitions.
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }

    Barba.Pjax.Dom.wrapperId = "main";
    Barba.Pjax.Dom.containerClass = "page";

    // Disable links while transition is in progress
    $("a").on("click", function (e) {
        if (CA.ajax_transition_active) {
            e.stopPropagation();
            e.preventDefault();
        }
    });

    var SubnavTransition = Barba.BaseTransition.extend({
        start: function () {
            Promise.all([this.newContainerLoading, this.fadeOut()]).then(this.fadeIn.bind(this));
        },
        fadeOut: function () {
            var tl = new TimelineLite();

            // Smooth-scrolling the whole page is itself a lot of motion, so
            // reduced motion jumps to the top instead.
            TweenMax.to(window, prefersReducedMotion() ? 0 : 1, {
                scrollTo: {
                    y: 0,
                    autoKill: false,
                },
                ease: Power4.easeInOut,
            });

            tl.to(
                "section:not(.hero)",
                0.5,
                CA.still({
                    opacity: 0,
                    y: "-40",
                    ease: Expo.easeIn,
                }),
                0
            );

            return tl;
        },
        fadeIn: function () {

            var _this = this,
                tl = new TimelineLite();

            tl.set(_this.oldContainer, { display: "none" });
            tl.set(_this.newContainer, { visibility: "visible" });

            tl.fromTo(
                $(_this.newContainer).find("section:not(.hero)"),
                0.5,
                CA.still({
                    opacity: 0,
                    y: "40",
                }),
                CA.still({
                    opacity: 1,
                    y: "0",
                    ease: Expo.easeOut,
                }),
                0
            );

            tl.add(function () {
                $("body").attr("class", CA.body_class);
            }, 0.5);

            tl.eventCallback("onComplete", function () {
                _this.done();
            });
        },
    });

    var OverlayTransition = Barba.BaseTransition.extend({
        start: function () {
            Promise.all([this.newContainerLoading, this.fadeOut()]).then(this.fadeIn.bind(this));
        },
        fadeOut: function () {
            var tl = new TimelineLite();

            tl.to(
                "header",
                0.5,
                {
                    opacity: 0
                },
                0
            );

            // The overlay's resting position already covers the viewport — the
            // slide is the only thing that moves it — so reduced motion fades
            // the curtain in rather than dropping the transform and leaving a
            // permanent black screen. autoAlpha also toggles visibility, so a
            // transparent curtain never swallows clicks. Each branch resets the
            // property the other one drives, in case the setting changed
            // between navigations.
            if (prefersReducedMotion()) {
                tl.fromTo(
                    ".overlay",
                    1,
                    {
                        y: "0%",
                        autoAlpha: 0,
                    },
                    {
                        autoAlpha: 1,
                        ease: Power1.easeInOut,
                    },
                    0
                );
            } else {
                tl.fromTo(
                    ".overlay",
                    1,
                    {
                        y: "100%",
                        autoAlpha: 1,
                    },
                    {
                        y: "0%",
                        ease: Expo.easeInOut,
                    },
                    0
                );

                tl.fromTo(
                    ".overlay img",
                    1,
                    {
                        rotationX: 90,
                        z: 100,
                    },
                    {
                        rotationX: 0,
                        z: 0,
                        ease: Power1.easeInOut,
                    },
                    0
                );
            }

            tl.to(
                this.oldContainer,
                1,
                CA.still({
                    opacity: 0,
                    y: -100,
                    ease: Expo.easeInOut,
                }),
                0
            );

            return tl;
        },
        fadeIn: function () {
            var _this = this,
                tl = new TimelineLite();

            tl.set(_this.oldContainer, { display: "none" });
            tl.call(CA.scroll_to_top);
            tl.set(_this.newContainer, CA.still({
                visibility: "visible",
                opacity: 0,
                y: 100,
                scale: 1.1,
            }));

            tl.to(
                "header",
                0.5,
                {
                    opacity: 1,
                },
                0.5
            );

            if (prefersReducedMotion()) {
                tl.fromTo(
                    ".overlay",
                    1,
                    {
                        y: "0%",
                        autoAlpha: 1,
                    },
                    {
                        autoAlpha: 0,
                        ease: Power1.easeInOut,
                    },
                    0
                );
            } else {
                tl.fromTo(
                    ".overlay",
                    1,
                    {
                        y: "0%",
                        autoAlpha: 1,
                    },
                    {
                        y: "-100%",
                        ease: Expo.easeInOut,
                    },
                    0
                );
            }

            tl.to(
                _this.newContainer,
                1,
                CA.still({
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    ease: Expo.easeInOut,
                }),
                0
            );

            tl.add(function () {
                $("body").attr("class", CA.body_class);
            }, 0.5);

            tl.eventCallback("onComplete", function () {
                $(".page").removeAttr("style");
                _this.done();
            });
        },
    });

    var QuickTransition = Barba.BaseTransition.extend({
        start: function () {
            Promise.all([this.newContainerLoading, this.fadeOut()]).then(this.fadeIn.bind(this));
        },
        fadeOut: function () {
            var tl = new TimelineLite();

            tl.to(
                this.oldContainer,
                0.5,
                CA.still({
                    opacity: 0,
                    y: -100,
                    ease: Expo.easeIn,
                }),
                0
            );

            return tl;
        },
        fadeIn: function () {
            var _this = this,
                tl = new TimelineLite();

            tl.set(_this.oldContainer, { display: "none" });
            tl.call(CA.scroll_to_top);
            tl.set(_this.newContainer, CA.still({
                visibility: "visible",
                opacity: 0,
                y: 100,
                scale: 1.1,
            }));

            tl.to(
                _this.newContainer,
                1,
                CA.still({
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    ease: Expo.easeOut,
                }),
                0
            );

            tl.add(function () {
                $("body").attr("class", CA.body_class);
            }, 0.25);

            tl.eventCallback("onComplete", function () {
                $(".page").removeAttr("style");
                _this.done();
            });
        },
    });

    var HideShowTransition = Barba.BaseTransition.extend({
        start: function () {
            Promise.all([this.newContainerLoading, this.fadeOut()]).then(this.fadeIn.bind(this));
        },
        fadeOut: function () {
            var tl = new TimelineLite();

            tl.to(
                this.oldContainer,
                0.1,
                {
                    opacity: 0,
                },
                0
            );

            return tl;
        },
        fadeIn: function () {
            var _this = this,
                tl = new TimelineLite();

            tl.set(_this.oldContainer, { display: "none" });
            tl.call(CA.scroll_to_top);
            tl.set(_this.newContainer, {
                visibility: "visible",
                opacity: 0,
            });

            tl.to(
                _this.newContainer,
                0.1,
                {
                    opacity: 1
                },
                0
            );

            tl.add(function () {
                $("body").attr("class", CA.body_class);
            }, 0.1);

            tl.eventCallback("onComplete", function () {
                $(".page").removeAttr("style");
                _this.done();
            });
        },
    });

    Barba.Pjax.getTransition = function () {
        if (!linkClicked) {
            return HideShowTransition;
        }

        // If the linkClicked is from the FAQ menu
        if ($(linkClicked).closest("nav.subnav").length) {
            return SubnavTransition;
        }

        if ($(linkClicked).closest("nav.filterbar").length) {
            return SubnavTransition;
        }

        if ($(linkClicked).closest(".filterbar-mobile-menu").length) {
            return SubnavTransition;
        }

        return QuickTransition;
    };

    Barba.Dispatcher.on("linkClicked", function (el) {
        linkClicked = el;
    });

    Barba.Dispatcher.on("initStateChange", function (args) {
        CA.init_active_nav();
        CA.ajax_transition_active = true;

        window.setTimeout(function () {
            CA.close_header_menu();
        }, 500);

        // Track pageview in Google Analytics
        if (!CA.initial_load && typeof ga === "function") {
            ga("send", "pageview", location.pathname);
        }

        // Track pageview in HubSpot
        if (!CA.initial_load) {
            _hsq.push(["trackPageView"]);
        }

        CA.initial_load = false;
    });

    Barba.Dispatcher.on("newPageReady", function (currentStatus, oldStatus, container, newPageRawHTML) {
        var regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
            match = regexp.exec(newPageRawHTML);

        CA.body_class = match && match[1] ? match[1] : "";
    });

    Barba.Dispatcher.on("transitionCompleted", function () {
        CA.ajax_transition_active = false;
        linkClicked = false;
        CA.init_on_load();
        $("body").removeClass("prevent-transitions");

        // Final safety net: if anything (lazy-loaded images, late layout
        // shifts, browser quirks) bumped the scroll position after the
        // transition's own scroll reset, force it back to the top once the
        // new page is fully in place.
        requestAnimationFrame(CA.scroll_to_top);
    });

    Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
    Barba.Pjax.preventCheck = function (evt, element) {
        if (!Barba.Pjax.originalPreventCheck(evt, element)) {
            return false;
        }

        if ($(element).closest(".yii-debug-toolbar").length) {
            return false;
        }

        return true;
    };

    Barba.Pjax.start();
    Barba.Prefetch.init();
};

CA.init_overlay = function () {
    var tl = new TimelineLite();

    tl.set(
        "body",
        {
            visibility: "visible",
        },
        0
    );

    tl.to(
        ".overlay img",
        0.25,
        {
            opacity: 1,
        },
        0.1
    );

    if (prefersReducedMotion()) {
        tl.to(
            ".overlay",
            1,
            {
                autoAlpha: 0,
                ease: Power1.easeInOut,
            },
            0.1
        );
    } else {
        tl.fromTo(
            ".overlay",
            1,
            {
                y: "0%",
            },
            {
                y: "-100%",
                ease: Expo.easeInOut,
            },
            0.1
        );
    }

    tl.fromTo(
        ".page",
        1,
        CA.still({
            opacity: 0,
            y: 100,
            scale: 1.1,
        }),
        CA.still({
            opacity: 1,
            y: 0,
            scale: 1,
            ease: Expo.easeInOut,
            onComplete: function () {
                $(".page").removeAttr("style");
            }
        }),
        0.1
    );
};

CA.init_sticky_header = function () {
    var html = $("html"),
        header = $("header"),
        win = $(window),
        scrollTop = 0,
        lastScrollTop = 0,
        direction = "down";

    win.scroll(function () {
        scrollTop = win.scrollTop();

        if (scrollTop > lastScrollTop && !html.hasClass("menu-active")) {
            header.removeClass("active");
            $(".sidebar-form").removeClass("offset-top");
            direction = "down";
        } else {
            header.addClass("active");
            $(".sidebar-form").addClass("offset-top");
            direction = "up";
        }

        if (direction == "down" && scrollTop > 100 && !header.hasClass("stuck")) {
            header.hide();
            header.addClass("stuck");

            window.setTimeout(function () {
                header.show();
            }, 100);
        }

        if (scrollTop == 0) {
            header.removeClass("stuck");
        }

        lastScrollTop = scrollTop;
    });
};

// Visible, focusable descendants of `scope`, in DOM order. jQuery's :visible
// only looks at layout boxes, so collapsed dropdowns — which stay laid out and
// are hidden with visibility — need the second filter to be excluded.
CA.focusable_elements = function (scope) {
    return scope
        .find("a[href], button, input, select, textarea, [tabindex]")
        .not("[disabled], [tabindex='-1']")
        .filter(":visible")
        .filter(function () {
            return $(this).css("visibility") !== "hidden";
        });
};

// Keep Tab cycling inside `scope` while it is acting as a modal layer.
CA.trap_tab = function (e, scope) {
    var focusable = CA.focusable_elements(scope),
        first = focusable.first(),
        last = focusable.last();

    if (!focusable.length) {
        return;
    }

    if (e.shiftKey && (document.activeElement === first[0] || !scope.has(document.activeElement).length)) {
        e.preventDefault();
        last.trigger("focus");
    } else if (!e.shiftKey && document.activeElement === last[0]) {
        e.preventDefault();
        first.trigger("focus");
    }
};

CA.close_header_menu = function () {
    $("html").removeClass("menu-active");
    $("header .menu-toggle").attr("aria-expanded", "false");
};

CA.init_header_menu = function () {
    var html = $("html"),
        header = $("header"),
        toggle = header.find(".menu-toggle"),
        menu = header.find("ul#menu");

    if (!toggle.length) {
        return;
    }

    var menu_is_open = function () {
        // The toggle is display:none from the md breakpoint up, where the menu
        // is a plain inline list and none of this applies.
        return html.hasClass("menu-active") && toggle.is(":visible");
    };

    toggle.on("click", function (e) {
        e.preventDefault();

        if (html.hasClass("menu-active")) {
            CA.close_header_menu();
            return;
        }

        html.addClass("menu-active");
        toggle.attr("aria-expanded", "true");
        menu.find("a").first().trigger("focus");
    });

    $(document).on("keydown.headermenu", function (e) {
        if (!menu_is_open()) {
            return;
        }

        if (e.key === "Escape" || e.key === "Esc") {
            CA.close_header_menu();
            toggle.trigger("focus");
            return;
        }

        // While the menu is open it covers the page, so keep focus inside the
        // header — the menu, the search form and the toggle all live there.
        if (e.key === "Tab") {
            CA.trap_tab(e, header);
        }
    });
};

CA.init_search_form = function () {
    var form = $("header form"),
        action = form.attr("action"),
        input = form.find("#searchInput");

    input.on("focus", function (e) {
        $("html").addClass("search-active");
    });

    input.on("blur", function (e) {
        if (!input.val()) {
            $("html").removeClass("search-active");
        }
    });

    form.on("submit", function (e) {
        e.preventDefault();

        if (input.val()) {
            $("html").removeClass("search-active");
            Barba.Pjax.goTo(action + "?" + form.serialize());

            window.setTimeout(function () {
                form[0].reset();
            }, 500);
        } else if (!$("html").hasClass("search-active")) {
            input.focus();
        }
    });

    $(window)
        .on(
            "resize",
            debounce(function () {
                input.attr("placeholder", "To search, type and press enter");
            }, 1000)
        )
        .resize();
};

CA.init_share_links = function () {
    $("body").on("click", ".share a", function (e) {
        e.preventDefault();
        var url = $(this).attr("href");
        popupwindow(url, "Share", 600, 460);
    });
};

CA.init_active_nav = function () {
    var currentUrl = window.location.href.replace(window.location.hash, "");

    // Remove the active class from other links
    $("header ul#menu a").removeClass("active");

    // Add the active class to header link with same href
    $('header ul#menu a[href="' + currentUrl + '"]').addClass("active");
};


CA.init_filterbar_menu = function () {
    // The panel is hoisted out of the Barba container so it can overlay the
    // page — which means the previous page's copy is still sitting in <body>
    // while this page ships its own inside the container. Drop the stale one
    // before promoting the current one, or they accumulate and every
    // ".filterbar-mobile-menu" selector starts hitting two elements.
    $(".filterbar-mobile-menu.in-the-right-spot").remove();
    $(".filterbar-mobile-menu").first().addClass("in-the-right-spot").insertAfter(".overlay");

    var nav = $("nav.filterbar, .filterbar-mobile-menu"),
        menu = nav.find("ul").not("ul ul"),
        items = menu.find("li").not(".overflow, .search-wrap"),
        links = menu.find("a"),
        // Only the category toggles — the search form's submit button also
        // lives inside this list and must not act as a dropdown trigger.
        toggle = menu.find("button.filtertoggle"),
        dropdown_link = menu.find(".dropdown-link"),
        dropdown_menu = menu.find(".dropdown-menu");

    if (!nav.length) {
        return;
    }

    // Close every open dropdown inside `scope`. Returns whether anything was
    // actually open, so Escape can fall through to the next thing to close.
    var close_dropdowns = function (scope, refocus) {
        var open = (scope && scope.length ? scope : nav).find(".dropdown-link.active");

        if (!open.length) {
            return false;
        }

        open.removeClass("active")
            .children("button.filtertoggle")
            .attr("aria-expanded", "false");

        if (!nav.find(".dropdown-link.active").length) {
            menu.removeClass("active");
        }

        if (refocus) {
            open.first().children("button.filtertoggle").trigger("focus");
        }

        return true;
    };

    var mobile_menu_is_open = function () {
        return $(".filterbar-mobile-menu").filter(":visible").length > 0;
    };

    var open_mobile_menu = function () {
        $("html").addClass("overflow-mobile-stuck");
        $(".mobile-menu-toggle-button").attr("aria-expanded", "true");
        gsap.fromTo(".filterbar-mobile-menu", {
            opacity: 0,
            display: "none"
        }, {
            opacity: 1,
            display: "flex",
            onComplete: function () {
                // Move focus into the panel so keyboard users aren't left
                // behind the overlay.
                $(".filterbar-mobile-menu:visible .filterbar-mobile-menu__close").first().trigger("focus");
            }
        });
    };

    var close_mobile_menu = function (refocus) {
        if (!mobile_menu_is_open()) {
            return false;
        }

        close_dropdowns($(".filterbar-mobile-menu"), false);
        $("html").removeClass("overflow-mobile-stuck");
        $(".mobile-menu-toggle-button").attr("aria-expanded", "false");
        gsap.fromTo(".filterbar-mobile-menu", {
            opacity: 1,
            display: "flex"
        }, {
            opacity: 0,
            display: "none"
        });

        if (refocus) {
            $(".mobile-menu-toggle-button").filter(":visible").first().trigger("focus");
        }

        return true;
    };

    toggle.on("click", function () {
        var button = $(this),
            item = button.parent(),
            was_open = item.hasClass("active");

        // Desktop bar and mobile panel share this markup, so only collapse
        // siblings within the one the button belongs to.
        close_dropdowns(item.closest("nav.filterbar, .filterbar-mobile-menu"), false);

        if (was_open) {
            return;
        }

        item.addClass("active");
        button.attr("aria-expanded", "true");
        menu.addClass("active");
    });

    links.on("click", function () {
        close_dropdowns(nav, false);
        menu.removeClass("active");
    });

    // These three selectors reach elements that outlive a Barba transition,
    // so namespace the handlers and clear them before rebinding.
    $(".mobile-menu-toggle-button").off("click.filterbar").on("click.filterbar", open_mobile_menu);

    $(".filterbar-mobile-menu__close").off("click.filterbar").on("click.filterbar", function () {
        close_mobile_menu(true);
    });

    $(".filterbar-mobile-menu .dropdown li a").off("click.filterbar").on("click.filterbar", function () {
        close_mobile_menu(false);
    });

    $(document).off("keydown.filterbar").on("keydown.filterbar", function (e) {
        if (e.key === "Escape" || e.key === "Esc") {
            // Innermost first: a dropdown inside the mobile panel closes before
            // the panel itself.
            if (mobile_menu_is_open()) {
                if (!close_dropdowns($(".filterbar-mobile-menu"), true)) {
                    close_mobile_menu(true);
                }
                return;
            }

            close_dropdowns($("nav.filterbar"), true);
            return;
        }

        // The panel is a modal layer over the page, so Tab must not walk off
        // into the content behind it.
        if (e.key === "Tab" && mobile_menu_is_open()) {
            CA.trap_tab(e, $(".filterbar-mobile-menu").filter(":visible"));
        }
    });

    // A click or a focus move outside an open dropdown closes it, the way a
    // menu button is expected to behave.
    $(document).off("click.filterbar focusin.filterbar").on("click.filterbar focusin.filterbar", function (e) {
        if ($(e.target).closest(".dropdown-link").length) {
            return;
        }

        close_dropdowns(nav, false);
    });
};

CA.init_subnav_menu = function () {
    var nav = $("nav.subnav"),
        menu = nav.find("ul").not("ul ul"),
        items = menu.find("li").not(".overflow, .search-wrap"),
        links = menu.find("a"),
        // The overflow trigger and the search submit are also buttons in this
        // list; neither should expand the mobile menu.
        toggle = menu.find("button.toggle"),
        search_link = menu.find(".search-wrap"),
        overflow_link = nav.find(".overflow"),
        overflow_menu = nav.find(".overflow > ul");

    if (!nav.length) {
        return;
    }

    var close_menu = function (refocus) {
        if (!menu.filter(".active").length) {
            return false;
        }

        menu.removeClass("active");
        toggle.attr("aria-expanded", "false");

        if (refocus) {
            toggle.filter(":visible").first().trigger("focus");
        }

        return true;
    };

    var close_overflow = function (refocus) {
        var open = overflow_link.filter(".active");

        if (!open.length) {
            return false;
        }

        open.removeClass("active").children("button").attr("aria-expanded", "false");

        if (refocus) {
            open.filter(":visible").first().children("button").trigger("focus");
        }

        return true;
    };

    toggle.on("click", function () {
        var opening = !menu.filter(".active").length;

        menu.toggleClass("active", opening);
        toggle.attr("aria-expanded", opening ? "true" : "false");
    });

    links.on("click", function () {
        close_menu(false);
    });

    overflow_link.on("click", function () {
        var item = $(this),
            opening = !item.hasClass("active");

        item.toggleClass("active", opening);
        item.children("button").attr("aria-expanded", opening ? "true" : "false");
    });

    $(document).off("keydown.subnav").on("keydown.subnav", function (e) {
        if (e.key !== "Escape" && e.key !== "Esc") {
            return;
        }

        if (!close_overflow(true)) {
            close_menu(true);
        }
    });

    $(document).off("click.subnav").on("click.subnav", function (e) {
        if ($(e.target).closest(".overflow").length) {
            return;
        }

        close_overflow(false);
    });

    $(window).resize(
        throttle(function () {
            nav.addClass("active");

            menu.prepend(items);

            if ($(window).width() < 992) {
                return;
            }

            var menu_width = menu.width(),
                width = overflow_link.width() + search_link.width(),
                i = 0,
                link;

            while (width < menu_width) {
                link = items.eq(i);
                width += link.width();
                i++;
            }

            items.slice(i).appendTo(overflow_menu);

            if (i >= items.length) {
                overflow_link.addClass("d-lg-none");
                overflow_link.removeClass("d-lg-block");
            } else {
                overflow_link.addClass("d-lg-block");
                overflow_link.removeClass("d-lg-none");
            }
        }, 100)
    );

    $(window).resize();
};

CA.init_category_filters = function () {
    var nav = $("nav.category-filters"),
        menu = nav.find("ul").not("ul ul"),
        items = menu.find("li").not(".overflow, .search-wrap"),
        links = items.find("a");

    if (!nav.length) {
        return;
    }

    links.on("click", function (e) {
        e.preventDefault();

        var link = $(this),
            category = link.data("category"),
            href = "/blog/partial/" + category,
            container = $("#category-partial"),
            newContent = "";

        var fadeOut = TweenMax.to(container, 0.5, {
            opacity: 0,
            y: 20,
            ease: Power1.easeIn,
        });

        var loadContent = $.get(href, function (data) {
            newContent = data;
        });

        Promise.all([loadContent, fadeOut]).then(function () {
            var newContainer = $(newContent),
                tl = new TimelineLite();

            if (newContainer.filter(".article-grid").length) {
                newContainer = newContainer.filter(".article-grid");
            } else {
                newContainer = newContainer.find(".article-grid");
            }

            container.replaceWith(newContainer);
            CA.init_scroll_observers();

            TweenMax.fromTo(
                newContainer,
                1,
                {
                    opacity: 0,
                    y: 20,
                },
                {
                    opacity: 1,
                    y: 0,
                    ease: Expo.easeOut,
                }
            );
        });
    });
};

CA.init_blog_pagination = function () {
    var body = $("body"),
        container = $("#category-page");

    if (!container.length) {
        return;
    }

    body.on("click", ".paginate", function (e) {
        e.preventDefault();

        var link = $(this);
        link.fadeTo(0.5, 0.5);

        $.get(this.href, function (data) {
            container.append(data);
            link.parent().remove();
            CA.init_scroll_observers();
        });
    });
};

CA.init_slider = function () {
    var container = $("section.slider"),
        slider = container.find(".slider-wrap"),
        links = slider.find("a");

    if (!slider.length) {
        return;
    }

    slider.flickity({
        freeScroll: false,
        contain: true,
        wrapAround: true,
        imagesLoaded: true,
        prevNextButtons: true,
        pageDots: true,
        arrowShape:
            "M6.406 51.669L53.09 98.384l-2.202 2.064-49.965-50 49.965-50 2.202 2.064L6.932 48.7h93.99v2.968H6.406z",
    });

    slider.on("change.flickity", function (event, index) {
        links.removeClass("video-active");
        links.find("iframe").remove();
    });

    links.each(function () {
        var link = $(this),
            video = urlParser.parse(this.href);

        if (!video) {
            return;
        }

        link.addClass("video");
        link.click(function (e) {
            e.preventDefault();
        });
    });

    slider.on("staticClick.flickity", function (event, pointer, cellElement, cellIndex) {
        var link = $(cellElement),
            video = urlParser.parse(cellElement.href),
            iframe,
            src;

        if (video.provider == "youtube") {
            src = "https://www.youtube.com/embed/" + video.id;
        } else if (video.provider == "vimeo") {
            src = "https://player.vimeo.com/video/" + video.id + "?byline=0&portrait=0&autoplay=1";
        } else {
            return;
        }

        iframe = $("<iframe>", {
            src: src,
            frameborder: 0,
            allowfullscreen: true,
        });

        link.append(iframe);
        link.addClass("video-active");
    });
};

CA.init_video = function () {
    var container = $("section.video"),
        video = container.find(".video");

    if (!video.length) {
        return;
    }

    video.on("click", function (e) {
        var link = $(this),
            video = urlParser.parse(this.href),
            iframe,
            src;

        e.preventDefault();

        if (video.provider == "youtube") {
            src = "https://www.youtube.com/embed/" + video.id;
        } else if (video.provider == "vimeo") {
            src = "https://player.vimeo.com/video/" + video.id + "?byline=0&portrait=0&autoplay=1";
        } else {
            return;
        }

        iframe = $("<iframe>", {
            src: src,
            frameborder: 0,
            allowfullscreen: true,
        });

        link.append(iframe);
        link.addClass("video-active");
    });
};

CA.init_scroll_animations = function () {
    window.setInterval(function () {
        $.each(CA.to_animate, function (i, el) {
            window.setTimeout(function () {
                $(el).addClass("active");
            }, 100 * i);
        });

        CA.to_animate = [];
    }, 100);
};

CA.update_animations = function () {
    $.each(CA.to_animate, function (i, el) {
        window.setTimeout(function () {
            $(el).addClass("active");
        }, i * 150);
    });

    CA.to_animate = [];
};

CA.init_scroll_observers = function () {
    var animationClasses = [
            ".fade-in-up",
            ".slide-in-left",
            ".slide-in-right",
            ".vertical-rule",
            ".sidebar ul",
            ".sidebar ol",
            ".sidebar dl",
        ],
        elements = document.querySelectorAll(animationClasses.join(", "));

    var observer = new IntersectionObserver(
        function (entries, self) {
            $.each(entries, function (i, entry) {
                if (entry.isIntersecting) {
                    CA.to_animate.push(entry.target);
                    self.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0,
        }
    );

    $.each(elements, function (i, el) {
        observer.observe(el);
    });
};

CA.init_button_animations = function () {
    $(".btn-outline-light, .btn-outline-dark").addClass("animate-outline").wrapInner("<span />");
};

CA.init_logo_ticker = function () {
    var container = $("section.logo-ticker"),
        rows = container.find(".logo-row");

    if (!rows.length) {
        return;
    }

    var observer = new IntersectionObserver(
        function (entries, self) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    window.setInterval(function () {
                        var active = rows.filter(".active"),
                            next = active.next().length ? active.next() : rows.eq(0),
                            tl = new TimelineLite();

                        tl.staggerTo(
                            active.find(".logo"),
                            0.75,
                            {
                                opacity: 0,
                                y: 20,
                                ease: Expo.easeIn,
                            },
                            0.1
                        );

                        tl.add(function () {
                            active.removeClass("active");
                            next.addClass("active");
                        });

                        tl.staggerFromTo(
                            next.find(".logo"),
                            0.75,
                            {
                                opacity: 0,
                                y: 20,
                            },
                            {
                                opacity: 1,
                                y: 0,
                                ease: Expo.easeOut,
                            },
                            0.1
                        );
                    }, 5000);

                    self.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0,
        }
    );

    observer.observe(container[0]);
};

// Typewriter instances from the previous page, so their event loops can be
// stopped before this page's are created.
CA.typewriters = [];

CA.init_typewriter = function () {
    var containers = $("[data-type]");

    $.each(CA.typewriters, function (i, handle) {
        handle.stop();
    });
    CA.typewriters = [];

    containers.each(function () {
        var el = this,
            strings = $(el).data("type").split(","),
            // Constructing a Typewriter empties its element, so keep the
            // server-rendered first phrase to fall back on.
            initialHTML = el.innerHTML,
            timer = null,
            running = false,
            everTyped = false,
            typewriter,
            handle;

        function build() {
            return new Typewriter(el, {
                strings: strings,
                loop: true,
                autoStart: true,
            });
        }

        typewriter = build();

        // Hold the first characters back until the page-load overlay is out of
        // the way; hero-controls.js may cancel that start entirely.
        typewriter.stop();

        // start/stop are the library's resume/suspend pair — the queue keeps its
        // place across them, so this doubles as a pause control for
        // hero-controls.js, which reaches the handle through the element.
        handle = {
            start: function () {
                window.clearTimeout(timer);
                timer = null;
                if (running) {
                    return;
                }
                running = true;
                everTyped = true;
                if (!typewriter) {
                    typewriter = build();
                    return;
                }
                typewriter.start();
            },
            stop: function () {
                window.clearTimeout(timer);
                timer = null;
                if (!running) {
                    // Suppressed before it ever typed a character — hand the
                    // element its original text back so the headline still
                    // reads as a sentence instead of a lone cursor. A later
                    // start() rebuilds from scratch.
                    if (!everTyped && typewriter) {
                        typewriter.stop();
                        typewriter = null;
                        el.innerHTML = initialHTML;
                    }
                    return;
                }
                running = false;
                typewriter.stop();
            },
        };

        timer = window.setTimeout(handle.start, 1000);

        el.__caTypewriter = handle;
        CA.typewriters.push(handle);
    });
};

CA.init_hubspot_forms = function () {
    var containers = $(".hbspt-form");

    // Make sure the Hubspot JS is loaded
    if (typeof hbspt == "undefined") {
        return;
    }

    if (!containers.length) {
        return;
    }

    containers.each(function (i, v) {
        var container = $(this),
            id = "hbspt-form-" + i;

        // Add a unique ID for the "target" param below
        container.attr("id", id);

        hbspt.forms.create({
            portalId: container.data("portal"),
            formId: container.data("form"),
            target: "#" + id,
            onFormSubmitted: function (form) {
                // If we are in a .call-to-action block, update the confirmation message
                // if (!form.closest(".call-to-action").length) {
                //     return;
                // }

                // var message = container.find(".submitted-message").text(),
                //     body = form.closest(".call-to-action").find(".form-body");

                // Add a line break on desktop
                // message = message.replace("!", '!<br class="d-none d-md-block" />');

                // // Replace the body with the confirmation message
                // TweenMax.set(body, { opacity: 0, y: 20 });
                // body.html($("<h2 />", { html: message }));
                // TweenMax.to(body, 2, { opacity: 1, y: 0, ease: Expo.easeOut });

                // // Remove the form container
                // container.remove();
            },
        });
    });
};

CA.init_nested_links = function () {
    $("body").on("mouseenter focus", "[data-href]", function () {
        var link = $(this).closest("a"),
            originalHref = link.attr("href"),
            newHref = $(this).data("href");

        link.data("originalHref", originalHref);
        link.attr("href", newHref);
    });

    $("body").on("mouseout blur", "[data-href]", function () {
        var link = $(this).closest("a"),
            originalHref = link.data("originalHref");

        link.attr("href", originalHref);
    });

    $("body").on("keyup", "[data-href]", function (e) {
        var link = $(this).closest("a");

        if (e.which == 13) {
            link[0].click();
        }
    });
};

CA.init_animated_underlines = function () {
    $("body").on("mouseenter", "a, button", function () {
        var link = $(this),
            underlines = link.find(".underline"),
            color = getComputedStyle(link[0]).color,
            obj = { color: "rgba(0,0,0,0)" };

        if (!underlines.length) {
            return;
        }

        // Special case for header links
        if (link.closest("header").length && $("body").hasClass("header-light")) {
            color = "#E1B966";
        }

        var tween = TweenMax.to(obj, 0.25, {
            colorProps: {
                color: color,
            },
            onUpdate: function () {
                var bg = "linear-gradient(to right, " + obj.color + ", " + obj.color + ")";
                TweenLite.set(underlines, {
                    backgroundImage: bg,
                });
            },
        });
    });

    $("body").on("mouseleave", "a, button", function () {
        var link = $(this),
            underlines = link.find(".underline"),
            color = getComputedStyle(link[0]).color,
            obj = { color: color };

        if (!underlines.length) {
            return;
        }

        // Special case for header links
        if (link.closest("header a.active").length && $("body").hasClass("header-light")) {
            color = "#FFFFFF";
        } else if (link.closest("header a.active").length) {
            color = "#000000";
        } else {
            color = "rgba(0,0,0,0)";
        }

        var tween = TweenMax.to(obj, 0.25, {
            colorProps: {
                color: color,
            },
            onUpdate: function () {
                var bg = "linear-gradient(to right, " + obj.color + ", " + obj.color + ")";
                TweenLite.set(underlines, {
                    backgroundImage: bg,
                });
            },
            onComplete: function () {
                underlines.css("backgroundImage", "");
            },
        });
    });
};

CA.init_animated_heading_underlines = function () {
    $("body").on("mouseenter", "h1 a, h2 a", function () {
        var link = $(this),
            color = "#333333",
            obj = { color: "#E4EAED" };

        var tween = TweenMax.to(obj, 0.25, {
            colorProps: {
                color: color,
            },
            onUpdate: function () {
                var bg = "linear-gradient(to right, " + obj.color + ", " + obj.color + ")";
                TweenLite.set(link, {
                    backgroundImage: bg,
                });
            },
        });
    });

    $("body").on("mouseleave", "h1 a, h2 a", function () {
        var link = $(this),
            color = "#E4EAED",
            obj = { color: "#333333" };

        var tween = TweenMax.to(obj, 0.25, {
            colorProps: {
                color: color,
            },
            onUpdate: function () {
                var bg = "linear-gradient(to right, " + obj.color + ", " + obj.color + ")";
                TweenLite.set(link, { backgroundImage: bg });
            },
            onComplete: function () {
                TweenLite.set(link, { backgroundImage: "linear-gradient(to right, #E4EAED, #E4EAED)" });
            },
        });
    });
};

CA.initAds = function() {

    if ($(".advertisement").length === 0) {
        return;
    }

    // The ad creatives are fixed-size HTML5 exports — the WxH suffix on the
    // folder name (e.g. _1200x1200) is the creative's native size, and it
    // won't reflow to a smaller iframe. So the iframe keeps the native size
    // and transform-scales down to the slot; the scale is paint-only, so
    // resizing never disturbs the creative. Returns false when no native
    // size can be parsed (then the caller falls back to placeholder sizing).
    function fitAd($iframe, $ad) {
        var match = ($iframe.attr("data-src") || $iframe.attr("src") || "").match(/(\d{2,4})x(\d{2,4})/);
        if (!match) {
            return false;
        }
        var nativeWidth = parseInt(match[1], 10);
        var nativeHeight = parseInt(match[2], 10);
        var scale = Math.min($ad.width() / nativeWidth, 1);
        $iframe.css({
            maxWidth: "none",
            width: nativeWidth + "px",
            height: nativeHeight + "px",
            transform: "scale(" + scale + ")",
            transformOrigin: "0 0",
            // the transform doesn't shrink the layout box; pull it back in
            marginRight: -(nativeWidth - nativeWidth * scale) + "px",
            marginBottom: -(nativeHeight - nativeHeight * scale) + "px"
        });
        return true;
    }

    function sizeiframes() {
        $(".advertisement iframe").each(function () {
            var $that = $(this);
            var $parent = $that.closest(".advertisement");
            if (fitAd($that, $parent)) {
                return;
            }
            var $img = $parent.find("img");
            var width = $img.width();
            var height = $img.height();
            $that.width(width);
            $that.height(height);
        });
    }

    sizeiframes();

    $(window).on("resize", function() {
        sizeiframes();
    });

    $(".advertisement").each(function() {
        var $that = $(this);
        var $iframe = $that.find("iframe");
        var touched = $(this).data("touched");

        if (touched) {
            return;
        }

        $(this).data("touched", true);

        if ($(this).find("img").length && $iframe.length) {
            $iframe.remove();
        }

        $(this).find(".advertisement__play").on("click", function() {
            $(this).replaceWith("<button class='advertisement__replay'>Replay</button>");
            $that.find("img").hide();
            // Size the iframe while it's still detached, then load: the
            // creative's first load must already see the corrected viewport.
            fitAd($iframe, $that);
            if (!$iframe.attr("src") && $iframe.attr("data-src")) {
                $iframe.attr("src", $iframe.attr("data-src")).removeAttr("data-src");
            }
            $that.prepend($iframe);
            $that.find(".advertisement__replay").on("click", function() {
                $iframe.remove();
                $that.prepend($iframe);
            });
        });
    });

    const grid = document.getElementsByClassName('ad-campaign-grid');

    Array.from(grid).forEach(function(item) {
        imagesLoaded( item, function() {
            const pkry = new Packery(item, {
                itemSelector: '.advertisement',
            });
        });
    });
};

CA.do_custom_select = function() {
    $("select:not(.gt_selector)").each(function() {
        var $select = $(this);
        $select.wrap('<div class="custom-select"></div>');
    });
};

CA.init_on_load = function () {
    CA.init_subnav_menu();
    CA.init_filterbar_menu();
    CA.init_category_filters();
    CA.init_blog_pagination();
    CA.init_slider();
    CA.init_video();
    CA.init_scroll_observers();
    CA.init_button_animations();
    CA.init_logo_ticker();
    CA.init_typewriter();
    CA.init_hubspot_forms();
    CA.initAds();
    initStickySidebar();
    initStars();
    // After init_typewriter above — this takes over the handles it created.
    initHeroControls();
};

$(document).ready(function () {
    CA.init_ajax();
    CA.init_overlay();
    CA.init_sticky_header();
    CA.init_header_menu();
    CA.init_search_form();
    CA.init_share_links();
    CA.init_scroll_animations();
    CA.init_nested_links();
    // CA.init_animated_underlines();
    // CA.init_animated_heading_underlines();
    CA.do_custom_select();
    // window.addEventListener('message', event => {
    //     if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
    //         console.log(event);
    //         var elementId = event.data.id;
    //         $(".hbspt-form[data-form='" + elementId + "']").each(function () {
    //             $selects = $(this).find("select");
    //             if ($(this).hasClass("custom-selected")) {
    //                 return;
    //             }
    //             $(this).addClass("custom-selected");
    //             customSelect($selects);
    //         });
    //     }
    //  });
});

$(window).on("load", function() {
    CA.initAds();
});